// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"InputSearch_searchIcon__28e2l"};